import { ANALYSIS_PLAN, COMP_TABLE, DASHBOARD, FUND_CHART, FUND_SCREENER, PORTFOLIO, SAVED_SCORE, SCATTER_PLOT, SCENARIO, STOCK_SCREENER, TALKING_POINT, TECH_CHART, TIMESERIES_TABLE, WATCHLIST, } from '../constants';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class ConverterService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getDiffURL(assetType) {
        switch (assetType) {
            case SAVED_SCORE:
                return this.urlsService.CONVERTERS.DIFF.SAVED_SCORE;
            case TALKING_POINT:
                return this.urlsService.CONVERTERS.DIFF.TALKING_POINT;
            case WATCHLIST:
                return this.urlsService.CONVERTERS.DIFF.WATCHLIST;
            case SCENARIO:
                return this.urlsService.CONVERTERS.DIFF.SCENARIO;
            case ANALYSIS_PLAN:
                return this.urlsService.CONVERTERS.DIFF.ANALYSIS_PLAN;
            case COMP_TABLE:
                return this.urlsService.CONVERTERS.DIFF.COMP_TABLE;
            case TIMESERIES_TABLE:
                return this.urlsService.CONVERTERS.DIFF.TIMESERIES_TABLE;
            case STOCK_SCREENER:
                return this.urlsService.CONVERTERS.DIFF.STOCK_SCREENER;
            case FUND_SCREENER:
                return this.urlsService.CONVERTERS.DIFF.FUND_SCREENER;
            case SCATTER_PLOT:
                return this.urlsService.CONVERTERS.DIFF.SCATTER_PLOT;
            case FUND_CHART:
                return this.urlsService.CONVERTERS.DIFF.FUND_CHART;
            case TECH_CHART:
                return this.urlsService.CONVERTERS.DIFF.TECH_CHART;
            case DASHBOARD:
                return this.urlsService.CONVERTERS.DIFF.DASHBOARD;
            case PORTFOLIO:
                return this.urlsService.CONVERTERS.DIFF.PORTFOLIO;
            default:
                throw new Error(`Convertible asset ${assetType} not supported.`);
        }
    }
    getApplyURL(assetType) {
        switch (assetType) {
            case SAVED_SCORE:
                return this.urlsService.CONVERTERS.APPLY.SAVED_SCORE;
            case TALKING_POINT:
                return this.urlsService.CONVERTERS.APPLY.TALKING_POINT;
            case WATCHLIST:
                return this.urlsService.CONVERTERS.APPLY.WATCHLIST;
            case SCENARIO:
                return this.urlsService.CONVERTERS.APPLY.SCENARIO;
            case ANALYSIS_PLAN:
                return this.urlsService.CONVERTERS.APPLY.ANALYSIS_PLAN;
            case COMP_TABLE:
                return this.urlsService.CONVERTERS.APPLY.COMP_TABLE;
            case TIMESERIES_TABLE:
                return this.urlsService.CONVERTERS.APPLY.TIMESERIES_TABLE;
            case STOCK_SCREENER:
                return this.urlsService.CONVERTERS.APPLY.STOCK_SCREENER;
            case FUND_SCREENER:
                return this.urlsService.CONVERTERS.APPLY.FUND_SCREENER;
            case SCATTER_PLOT:
                return this.urlsService.CONVERTERS.APPLY.SCATTER_PLOT;
            case FUND_CHART:
                return this.urlsService.CONVERTERS.APPLY.FUND_CHART;
            case TECH_CHART:
                return this.urlsService.CONVERTERS.APPLY.TECH_CHART;
            case DASHBOARD:
                return this.urlsService.CONVERTERS.APPLY.DASHBOARD;
            case PORTFOLIO:
                return this.urlsService.CONVERTERS.APPLY.PORTFOLIO;
            default:
                throw new Error(`Convertible asset ${assetType} not supported.`);
        }
    }
    /**
     * Requests the eventual diffs that an asset would have if we try to convert it to a generic asset.
     *
     * @param assetType Type of asset from which we are trying to get the diff.
     * @param assetId ID of asset from which we are trying to get the diff.
     */
    getDiff(assetType, assetId) {
        const url = this.urlsService.getUrl(this.getDiffURL(assetType), { assetId });
        return this.ajaxService.getDataObserveResponse(url);
    }
    /**
     * Converts an asset to a generic asset.
     *
     * @param assetType Type of asset from which we are trying to convert.
     * @param assetId ID of asset from which we are trying to convert.
     * @param convertParams POST parameters required for the endpoint.
     */
    convert(assetType, assetId, convertParams) {
        const url = this.urlsService.getUrl(this.getApplyURL(assetType), { assetId });
        return this.ajaxService.postJsonDataObserveResponse(url, convertParams);
    }
}
ConverterService.ɵfac = function ConverterService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConverterService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
ConverterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConverterService, factory: ConverterService.ɵfac, providedIn: 'root' });
